import Spinner from 'Common/Spinner'
import { useMediaQuery } from 'CustomHooks/useMediaQuery'
import React from 'react'
import { LuCircleHelp, LuCreditCard, LuShield } from 'react-icons/lu'
import { Tooltip } from 'react-tooltip'

const GuestPaymentPortalForm = ({ model, handleChange, validationModel, handleActiveForm, authorizePatient }) => {
  const isMobile = useMediaQuery('(max-width: 767px)')
  return (
    <>
      <Tooltip id="PaymentPortal_tooltip" place="top" style={{ zIndex: 2, width: isMobile ? 300 : 500, backgroundColor: "black" }} />
      <div className={`min-h-screen paymentWrapper bg-gradient-to-br  from-indigo-50 to-purple-50 flex`}>
        <div className="flex items-center justify-center flex-1 p-4 lg:pl-0">
          <div className="w-full max-w-2xl">
            <div className="bg-white border border-gray-100 shadow-xl rounded-2xl">
              <div className="p-5 sm:p-12">
                {/* Header */}
                <div className="mb-8 text-center">
                  <div className={`inline-flex items-center justify-center w-16 h-16 bg-indigo-500 rounded-full mb-4`}>
                    <LuCreditCard className="w-8 h-8 text-white" />
                  </div>
                  <h1 className="mb-2 text-3xl font-bold text-gray-900">Guest Payment Portal</h1>
                  <p className="leading-relaxed text-gray-600">
                    Enter your invoice number to make a payment as a guest.
                  </p>
                </div>

                <div className="space-y-6">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <label htmlFor="invoice" className="block text-sm font-semibold text-gray-700 required"> Invoice Number</label>
                      <LuCircleHelp data-tooltip-id="PaymentPortal_tooltip" data-tooltip-content="You can find your invoice number on the paper statement, email, or text message we sent you." className="w-4 h-4 text-gray-400 transition-colors hover:text-blue-500 cursor-help" />
                    </div>
                    <div className="relative">
                      <input
                        id="invoice"
                        name="invoiceNumber"
                        className={`w-full px-4 py-3 h-10 border-2 rounded-lg focus:ring-1 outline-none focus:ring-indigo-400 focus:border-indigo-400 transition-colors duration-200 border-gray-200 hover:border-gray-300  `}
                        placeholder="Enter your invoice number" value={model.loginModel.invoiceNumber} onChange={handleChange}
                      />
                      {validationModel.invoiceNumberError}
                    </div>
                  </div>
                  <button onClick={authorizePatient} className={`w-full bg-gradient-to-r !mt-8 from-indigo-500 to-purple-500 hover:from-indigo-600 hover:to-purple-600 text-white font-semibold py-3 rounded-lg transition-all duration-200 transform hover:scale-[1.02] focus:ring-4 focus:ring-indigo-200 focus:outline-none shadow-lg`} >
                    View Payment{' '}
                    {model.loader && <Spinner size={14} />}
                  </button>

                  <div className='w-full text-center'>
                    <button onClick={() => handleActiveForm("paymentPortalForm")} className="text-sm font-medium text-blue-600 transition-colors hover:text-blue-700 hover:underline">Back to Secure Login</button>
                  </div> 
                </div>
                {/* Help Section */}
                <div className="pt-6 mt-6 border-t border-gray-100">
                  <div className="flex items-center justify-center gap-2 text-sm text-gray-500">
                    <LuShield className="w-4 h-4" />
                    <span>Your information is secure and HIPAA compliant</span>
                  </div>
                  <div className="mt-3 text-center">
                  </div>
                </div>
                <div className='text-center'>
                  <button data-tooltip-id="PaymentPortal_tooltip" data-tooltip-html="<div><div class=' font-semibold mb-2'>To view and pay securely:</div><div class='mb-2'>1. Enter your Invoice Number provided.<div class='border-t border-gray-400 pt-2'><div class='font-semibold'>Still Need help?</div><div>Call the billing department at the provider's office.</div></div></div>" className="text-sm font-medium text-blue-600 transition-colors hover:text-blue-700 hover:underline">
                    Need help finding your invoice?
                  </button>
                </div>
              </div>
            </div>
            {/* Footer */}
            <div className="mt-6 text-center">
              <p className="text-sm text-gray-500">
                Powered by <a href="https://gettrucare.com" target="_blank" rel="noopener noreferrer" className="font-semibold text-gray-700 hover:underline">Trucare</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>

  )
}

export default GuestPaymentPortalForm